<template>
  <div class="indexCont">
    <div class="mainCont">
      <el-button class="gt_back" type="primary" icon="el-icon-arrow-left" size="small" @click="$router.push('./trainRecord')">返回</el-button>
      <div class="whiteBg">
        <div class="btnArr">
            <span>
                <img src="../../../assets/images/common/video2.png" alt="">
                <div>培训时长排行榜</div>
            </span>
            <span @click="goPage('./testRank')">
                <img src="../../../assets/images/common/record1.png" alt="">
                考试证书排行榜
            </span>
        </div>
        <div class="testCont">
            <el-table
            :data="dataList"
            stripe
            style="width: 100%"
            v-loading="loading"
            element-loading-spinner="el-icon-loading"
            element-loading-text="拼命加载中"
            >
                <el-table-column prop="rank" align="center" label="排名" >
                    <template slot-scope="scope">
                        <img src="../../../assets/images/home/one.png" alt="" v-show="scope.row.rank == 1">
                        <img src="../../../assets/images/home/two.png" alt="" v-show="scope.row.rank == 2">
                        <img src="../../../assets/images/home/three.png" alt="" v-show="scope.row.rank == 3">
                        <div v-show="scope.row.rank > 3">{{scope.row.rank}}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="username" align="center" label="姓名"></el-table-column>
                <el-table-column prop="departmentName" align="center" label="部门"></el-table-column>
                <el-table-column prop="learnTime" align="center" label="培训时长"></el-table-column>
            </el-table>
        </div>
        <div class="page">
            <el-pagination
            background
            layout="prev, pager, next"
            :total="dataInfo.total"
            @current-change="changePage"
            ></el-pagination>
        </div>
      </div>
    </div>
    <!-- 移动端显示 -->
    <div class="mobileTest">
      <MobileComNav title="排行榜" url="./trainRecord"></MobileComNav>
      <div class="switchTest">
        <div class="active">培训时长排行榜</div>
        <div @click="goPage('./testRank')">考试证书排行榜</div>
      </div>
      <div class="mt_cont" v-show="!isShow">
        <div class="mt_item" v-for="(item,index) in dataList" :key="index">
          <div class="m_rank">
              <span>排名：</span>
              <img src="../../../assets/images/home/one.png" alt="" v-show="item.rank == 1">
              <img src="../../../assets/images/home/two.png" alt="" v-show="item.rank == 2">
              <img src="../../../assets/images/home/three.png" alt="" v-show="item.rank == 3">
              <span v-show="item.rank > 3">{{item.rank}}</span>
          </div>
          <div class="time">姓名：{{item.username}}</div>
          <div class="time">部门：{{item.departmentName}}</div>
          <div>培训时长：{{item.learnTime}}分钟</div>
        </div>
      </div>
      <div class="comTxt" v-show="isShow">暂无数据</div>
    </div>
  </div>
</template>

<script>
import MobileComNav from "../../../components/mobileHead";
export default {
  data() {
    return {
        loading: true,
        dataInfo:{},
        dataList:[],
        curPage: 1,
        isShow:false,
        pageSize:10,
    };
  },
  mounted() {
    document.title = this.$route.meta.title;
  },
  components: {
    MobileComNav
  },
  created() {
    if(this.$IsPc()){
      this.pageSize = 10000;
    };
    this.paperList();
  },
  methods: {
    goPage(url) {
      this.$router.push(url);
    },
    paperList() {
      let url = this.$config.baseApi + "/material/resource/leaderBoard";
      this.$ajax({
        url: url,
        method: "post",
        data: JSON.stringify({
          current:this.curPage,
          pageSize:this.pageSize
        })
      })
        .then(res => {
          if (res.code == 1) {
            this.dataList = res.data.list;
            if(res.data.total == 0){
              this.isShow = true
            }
            this.dataInfo = res.data;
            this.loading = false;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 分页改变
    changePage(pageIndex) {
      this.curPage = pageIndex;
      this.paperList();
    },
  }
};
</script>

<style scoped>
@import "../../../assets/css/home/test.css";
.gt_back{
    margin:0.1rem 0 0.1rem;
}
.mainCont {
  margin-bottom: 0.2rem;
}
.whiteBg{
    padding: 0.23rem 0.2rem;
    background:#fff;
}
.testCont{
    margin:0.4rem 0 0.1rem;
}
.btnArr{
    border-bottom: 1px solid #e8e8e8;
   position: relative;
}
.btnArr .rank{
  position: absolute;
  top:0;
  right:0;
}
.btnArr span{
    display: inline-block;
    height: 0.42rem;
    width:1.6rem;
    line-height: 0.42rem;
    text-align: center;
    cursor: pointer;
}
.btnArr span img{
    height: 0.15rem;
}
.btnArr span:nth-child(1){
    position: relative;
    border-bottom:0.03rem solid #417ccb;
    color:#417ccb;
}
.btnArr span:nth-child(1) div{
    margin-left:0.15rem;
}
.btnArr span:nth-child(1) img{
    height: 0.16rem;
    position: absolute;
    top: 0.13rem;
    left: 0.06rem;
}
.el-table__row img{
    height:0.4rem;
}
@media screen and (max-width: 768px) {
  .mainCont {
    display: none;
  }
  .m_rank{
    display: flex;
    align-items: center;
  }
  .m_rank img{
      height: 0.6rem;
  }
  .mobileTest {
    display: block;
  }
  .mt_cont{
    line-height:0.6rem;
  }
}
</style>
